import React, {useState, useEffect} from "react";

import "./TableSearch.css";

export const TableSearch = ({dataToFilter, setFilteredData, setCurrentPage}) => {

    const [searchString, setSearchString] = useState("");

    useEffect(() => {
        if (searchString.length > 2) {
            filter();
        } else {
            setFilteredData(dataToFilter);
        }
    }, [searchString]);

    const filter = () => {
        const filteredData = [];
        dataToFilter.forEach((object) => {
            let string = "";
            for (const property in object) {
                string = string + object[property];
            }
            if (string.toLowerCase().includes(searchString.toLowerCase())) {
                filteredData.push(object);
            }
        });
        setCurrentPage(0);
        setFilteredData(filteredData);
    }

    const handleChange = ({target}) => {
        setSearchString(target.value);
    }

    return (
        <div className="table-search-container">
            <input data-testid="test-input" className="text-input" placeholder="Search..." onChange={handleChange}/>
        </div>
    )
}
